export const DEPOSITS = 1;
export const WITHDRAWALS = 2;
const CHALLENGE_WIN = 6;
const RAPIDFIRE_WIN = 14;
export const WINS = [CHALLENGE_WIN, RAPIDFIRE_WIN];
